// @flow
import * as React from 'react';
import { useContext } from 'react';
import LandingPage from 'pages/__components__/LandingPage';
import QuestionSearch from 'containers/search/Questions';
import NetworkQuestionSearch from 'containers/search/NetworkQuestions';
import AnswerSearch from 'containers/search/Answers';
import ChannelsDashboard from 'containers/channels/Channels';
import UgcAssignmentProvider from 'containers/client/UgcAssignmentProvider';
import { AnswerEditingContext } from 'containers/answer-editing/AnswerEditingContext';
import { ClientContentCardProvider } from 'context/content-card-context';
import { ClientContext } from 'containers/client/ClientProvider';
import { getIsPwrDistroClient } from '../components/ModerationCard/ClientModerationCard/utils';
import {
  QuestionSearch as PwrDistroQuestionSearch,
  AnswerSearch as PwrDistroAnswerSearch,
} from 'containers/search/PwrDistribution';

class QAChannels extends React.PureComponent<*> {
  render() {
    return <ChannelsDashboard ugctype="Question" {...this.props} />;
  }
}

const channelsRoute = {
  path: 'channels',
  component: QAChannels,
  label: 'Channels',
  navItem: true,
};

const questionSearchRoute = {
  exact: false,
  path: 'questions',
  label: QuestionSearch.label,
  component: QuestionSearch,
  navItem: true,
};

const networkQuestionSearchRoute = {
  exact: false,
  path: 'network-questions',
  label: NetworkQuestionSearch.label,
  component: NetworkQuestionSearch,
  navItem: true,
};

const answerSearchRoute = {
  exact: false,
  path: 'answers',
  label: AnswerSearch.label,
  component: AnswerSearch,
  navItem: true,
};

const pwrDistroQuestionsRoute = {
  exact: false,
  path: 'questions-search',
  label: 'Questions',
  component: PwrDistroQuestionSearch,
  navItem: true,
};

const pwrDistroNetworkQuestionsRoute = {
  exact: false,
  path: 'answers-search',
  label: 'Answers',
  component: PwrDistroAnswerSearch,
  navItem: true,
};

const pwrDistroSearchRoutes = [
  channelsRoute,
  pwrDistroQuestionsRoute,
  pwrDistroNetworkQuestionsRoute,
  { ...questionSearchRoute, navItem: false },
  { ...networkQuestionSearchRoute, navItem: false },
  { ...answerSearchRoute, navItem: false },
];

const oldUgcRoutes = [
  channelsRoute,
  questionSearchRoute,
  networkQuestionSearchRoute,
  answerSearchRoute,
  { ...pwrDistroQuestionsRoute, navItem: false },
  { ...pwrDistroNetworkQuestionsRoute, navItem: false },
];

const channelOnlySlice = [channelsRoute];

export const ugcSearchPathname = (ugc: Ugc): ?string => {
  if (ugc.ugc_archetype === 'Question') {
    return questionSearchRoute.path;
  }

  if (ugc.ugc_archetype === 'Answer') {
    return answerSearchRoute.path;
  }

  return null;
};

export default (props: { ...UserInfo, ...ContextRouter }) => {
  const clientProps = useContext(ClientContext);

  let routes;
  if (clientProps && getIsPwrDistroClient(clientProps.clientId, clientProps)) {
    routes = pwrDistroSearchRoutes;
  } else if (props.access.search) {
    routes = oldUgcRoutes;
  } else {
    routes = channelOnlySlice;
  }

  return (
    <ClientContentCardProvider>
      <AnswerEditingContext.Provider>
        <UgcAssignmentProvider>
          <LandingPage
            label="Q&A"
            routes={routes}
            showMerchantGroupSelect
            landingRoute={'channels'}
            {...props}
          />
        </UgcAssignmentProvider>
      </AnswerEditingContext.Provider>
    </ClientContentCardProvider>
  );
};



// WEBPACK FOOTER //
// ./src/pages/qa.js